<template>
  <div class="system_content">
    <div class="header_box">
      <div class="el-header dynamic_width">
        <div class="header-content">
          <div class="title" @click="backToHome">
            <img :src="require('@/assets/Erp_logo@2x.png')" alt="" />
            <!-- <span>&nbsp;|&nbsp;</span>
            <span>服务市场</span> -->
          </div>
          <div class="middle-search" v-if="isShowInfo">
            <el-input
              placeholder="请输入规格名称、应用名称搜索..."
              v-model="searchContent"
              @keyup.enter.native="jumpToSearch"
            >
              <i slot="prefix" class="el-input__icon el-icon-search"></i>
              <span slot="append" @click="jumpToSearch">搜索</span>
            </el-input>
          </div>
          <div class="float-text" v-if="isShowInfo">
            <span @click="jumpToSellerCenter">商户中心</span>
            <span>|</span>
            <span @click="jumpToNotice"><img :src="noticeIcon" alt="" /></span>
            <el-popover
              popper-class="header-popover"
              ref="popover1"
              placement="bottom-start"
              :visible-arrow="false"
              :append-to-body="false"
              trigger="hover"
            >
              <span slot="reference"
              @click="jumpToUserCenter"
                >{{ userMessage.nick }}
                <img :src="require('@/assets/arrow@2x.png')" alt="" />
              </span>
              <span style="text-align: right" @click="cancelAccount">
                <svg class="icon" aria-hidden="true">
                  <use xlink:href="#icon-zhuxiao"></use>
                </svg>
                退出登录
              </span>
            </el-popover>

            <!-- <span>{{ userMessage.nick }}</span>
            <span @click="cancelAccount">注销</span> -->
          </div>
        </div>
      </div>
    </div>
    <!-- 导航屑 -->
    <div class="bread_box dynamic_width">
      <bread-crumb></bread-crumb>
    </div>
    <div class="el-main el-container dynamic_width">
      <slot name="mainContent"></slot>
    </div>
    <!-- 回到顶部的块 -->
    <div class="backToTop" @click="backToTop" v-if="isShowArrow">
      <div class="icon_box">
        <!-- <svg class="icon" aria-hidden="true">
          <use xlink:href="#icon-jiantou_xiangshang"></use>
        </svg> -->
      </div>
    </div>
    <div class="friend_chain" v-permission="['APP_QUERY']" v-if="checkUrl()">
      <img :src="require('@/assets/app.png')" /><span class="friend_chain_font">APP扫码下载</span>
      <img :src="require('@/assets/wechatAcc.png')" /><span class="friend_chain_font">扫码关注</span>
<!--      <el-button class="friend_chain_button" type="primary" @click="dialogVisible = true">我要吐槽</el-button>-->
      <el-button class="friend_chain_button" type="primary" @click="jumpToPublishNeeds">我有需求</el-button>
    </div>
    <div class="footer_box">
      <div class="el-footer dynamic_width">
        <span class="text-btn" @click="pAVisible = true">《服务市场隐私政策》</span>
        <span>北京掌上先机网络科技有限公司 版权所有</span>
        <span>京ICP备13053703号-1京公网安备 11010802028288号</span>
      </div>
    </div>
    <pAgreement v-if="pAVisible" title="服务市场隐私政策" type="privacy" @closeDialog="pAVisible = false"></pAgreement>
    <!-- 吐槽弹窗 -->
    <roast-dialog v-if="checkUrl()" :visible.sync="dialogVisible" />
  </div>
</template>
<script>
import BreadCrumb from "@/views/userViews/components/BreadCrumb";
import roastDialog from "@/views/userViews/roast";
import { jwtToken } from "@/utils/tools.js";
import { cancleAccount } from "@/api/login.js";
import pAgreement from "@/views/userViews/pAgreement";
// import { searchApplication } from "@/api/frontApi.js";
export default {
  components: {
    BreadCrumb,
    roastDialog,
    pAgreement
  },
  props: {
    inputParam: {
      type: String,
      default: "",
    },
    isShowInfo: {
      type: Boolean,
      default: true,
    },
  },
  data() {
    this.noticeIcon = require("@/assets/notice@2x.png");
    return {
      isShowArrow: false,
      dialogVisible: false,
      userMessage: {},
      searchContent: "", //this.searchText
      // isSearchByInput:false,  //是否手动输入的搜索条件
      pAVisible: false,
    };
  },
  mounted() {
    // 解析token获取用户信息
    // this.$store.commit("setAccountInfo", this.$store.state.token);
    this.userMessage = jwtToken(this.$store.state.token);
    window.addEventListener("scroll", this.windowScroll);
  },
  beforeDestroy() {
    window.removeEventListener("scroll", this.windowScroll);
  },
  methods: {
    checkUrl() {
      return !['/login', '/blankpage'].includes(this.$route.path)
    },
    backToTop() {
      cancelAnimationFrame(timer);
      let timer = requestAnimationFrame(function scrolling() {
        let toTop =
          document.body.scrollTop || document.documentElement.scrollTop;
        if (toTop > 0) {
          scrollBy(0, -100);
          timer = requestAnimationFrame(scrolling);
          // window.scrollTo(0,0)
        } else {
          cancelAnimationFrame(timer);
        }
      });
    },

    windowScroll() {
      let toTop = document.body.scrollTop || document.documentElement.scrollTop;
      this.isShowArrow = toTop > 0 ? true : false;
    },
    jumpToSellerCenter() {
      this.$router.push("/usersystem/sellercenter/myapplication");
    },
    jumpToNotice() {
      this.$router.push("/usersystem/noticecenter");
    },
    // 注销账户
    cancelAccount() {
      this.$confirm("是否确认注销账号?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        // type: "warning",
      }).then(() => {
        this.cancleAccountMethod();
        this.$router.push("/login");
      });
    },
    async cancleAccountMethod() {
      await cancleAccount();
    },
    backToHome() {
      if (this.isShowInfo) {
        this.$router.push("/usersystem/home");
      }
    },
    jumpToSearch() {
      // 将输入框内容传给search组件
      this.$emit("getSearchInput", this.searchContent);
      if (this.$route.path === "/usersystem/search") {
        // 搜索页面
        return;
      } else {
        // 不是搜索页面
        this.$router.push({
          path: "/usersystem/search",
          query: { keyword: this.searchContent },
        });
      }
    },
    jumpToUserCenter(){
      this.$router.push('/usersystem/sellercenter/usercenter')
    },
    jumpToPublishNeeds(){
        this.$router.push('/usersystem/needsPublish')
    }
  },
  watch: {
    inputParam(val) {
      this.searchContent = val;
    },
  },
};
</script>
<style lang="scss" scoped>
.system_content::v-deep {
  min-height: 100vh;
  margin-left: auto;
  margin-right: auto;
  display: flex;
  flex-direction: column;
  .header_box {
    width: 100%;
    background-color: white;
  }
  .el-header {
    width: 100%;
    padding: 0px;
    color: #242f57;
    height: 80px;
    line-height: 80px;
    margin: 0 auto;
    // background-color: white;
    .header-content {
      display: flex;
      width: 70%;
      height: inherit;
      margin-left: auto;
      margin-right: auto;
      .title {
        display: flex;
        flex-direction: row;
        align-items: center;
        font-weight: 600;
        cursor: pointer;
        font-size: 22px;
        color: #a5aabb;
        img {
          // width: 103px;
          height: 45px;
          vertical-align: middle;
        }
        > span:nth-last-child(1) {
          color: #242f57;
        }
      }
      .middle-search {
        display: inline-block;
        width: 40%;
        margin: 0 auto;
        .el-input-group > .el-input__inner {
          border: 2px solid $content-fontColor;
        }
        .el-input-group__append {
          width: 15%;
          font-size: 16px;
          background-color: $content-fontColor;
          color: white;
          text-align: center;
          padding: 0px;
          border: 1px solid $content-fontColor;
          span {
            display: inline-block;
            width: 100%;
            line-height: 38px;
            cursor: pointer;
          }
        }
        // 修改输入的光标颜色
        .el-input {
          caret-color: $content-fontColor;
        }
        @supports (-webkit-mask: none) and (not (caret-color: red)) {
          .el-input {
            color: $content-fontColor;
          }
        }
      }
    }

    .float-text {
      width: auto;
      display: flex;
      justify-content: space-between;
      font-size: 14px;
      color: $content-titleColor;
      img {
        border-radius: 50%;
        object-fit: cover;
      }
      span {
        display: inline-block;
        margin-left: 10px;
        cursor: pointer;
        // 通知图标、姓名旁边的箭头
        > img {
          width: 20px;
          height: 20px;
          vertical-align: middle;
        }
      }
      span:nth-child(4) {
        // 账户名字
        position: relative;
        color: #242f57;
        font-size: 14px;
        cursor: default;
        .el-popover.header-popover {
          top: 45px !important;
          > span {
            cursor: pointer;
          }
        }
        .el-popover {
          min-width: 100px;
          padding: 8px;
        }
      }
    }
  }
  .bread_box {
    width: 100%;
    margin: 0 auto;
  }
  .el-breadcrumb {
    width: 70%;
    min-height: 20px;
    // height: 40px;
    line-height: 40px;
    margin-left: 15%;
  }
  .el-container {
    width: 100%;
  }
  .el-main {
    overflow: hidden;
    padding: 0px;
    height: auto;
    margin: 0 auto;
    // width: 100%;
    display: flex;
    flex-direction: row;
    justify-content: space-between;
  }
  .footer_box {
    background-color: #ebedf0;
    width: 100%;
    margin-top: 20px;
    .el-footer {
      width: 100%;
      display: flex;
      margin: 0 auto;
      flex-direction: column;
      justify-content: center;
      height: 80px;
      font-size: 12px;
      text-align: center;
      color: #8c8c8c;
      background-color: #ebedf0;
    }
  }

  .backToTop {
    position: fixed;
    bottom: 100px;
    right: 10%;
    width: 40PX;
    height: 40PX;
    border-radius: 4px;
    text-align: center;
    font-size: 12px;
    color: white;
    // background-color: #305496;
    .icon_box {
      position: relative;
      width: 100%;
      height: 100%;
      background: url("~@/assets/back_arrow@2x.png");
      background-size: 100%;
    }
    .icon_box:hover {
      background: url("~@/assets/back_text@2x.png");
      background-size: 100%;
    }
  }

  .friend_chain {
    position: fixed;
    bottom: 20px;
    right: 15px;
    width: 100px;
    img {
      width: 100px;
    }
    &_button {
      margin-top: 35px;
    }
    &_font {
      display: inline-block;
      width: 100%;
      font-size: 14px;
      text-align: center;
      font-weight: bold;
      color: $content-fontColor;
    }
  }
}


// 1024 1280 1366 1440 1680 1920
@media screen and (min-width: 1024px) {
  .system_content .dynamic_width {
    width: 100%;
  }
}

@media screen and (min-width: 1714px) {
  // 大屏
  .system_content .dynamic_width {
    width: 1714px;
  }
}
</style>
